import React from 'react';
import ObjectiveForm from '@components/objectives/ObjectiveForm';
import withObjective from '@hoc/withObjective';
import { useGetCurrentUserQuery } from '@teachur/http-client';

interface EditObjectiveProps {
  objective: Objective;
}

const EditObjective: React.FC<EditObjectiveProps> = ({ objective }) => {
  const { data: user } = useGetCurrentUserQuery();

  if (!user) {
    return null;
  }

  return <ObjectiveForm objective={objective} />;
};

const ConnectedEditObjective = withObjective(EditObjective);

const Page = () => <ConnectedEditObjective />;

export default Page;
